<template>

	<!-- Active Users Card -->
	<a-card :bordered="false" class="dashboard-bar-chart header-solid">
		<template #title>
			<h6>近半年实际入账金额</h6>
			<p>统计条件为：收款审核已通过客户付款金额 <span class="text-success"></span></p>
		</template>
		<chart-bar :height="220" :data="barChartData"></chart-bar>
		<div class="card-title">
			<h6>单日数据</h6>
			<p>Other data <span class="text-success"></span></p>
		</div>
		<!-- <div class="card-content">
			<p>We have created multiple options for you to put together and customise into pixel perfect pages.</p>
		</div> -->
		<a-row class="card-footer" type="flex" justify="center" align="top">
			<a-col :span="12">
				<h4>¥{{ yesterShoukuan }}</h4>
				<span>昨日财务入账</span>
			</a-col>
			<a-col :span="12">
				<h4>¥{{ todayShouwkuan }}</h4>
				<span>今日财务入账</span>
			</a-col>
			<!-- <a-col :span="6">
				<h4>{{ todayTotalCountDatas }}</h4>
				<span>今日有效成交</span>
			</a-col>
			<a-col :span="6">
				<h4>772</h4>
				<span>今日复够成交</span>
			</a-col> -->
		</a-row>
	</a-card>
	<!-- Active Users Card -->

</template>

<script>

// Bar chart for "Active Users" card.
import ChartBar from '../Charts/ChartBar';

export default ({
	components: {
		ChartBar,
	},
	props: {
		barChartData: Object,
		yesterShoukuan: {
			type: [String, Number],
			default: "0"
		},
		todayShouwkuan: {
			type: [String, Number],
			default: "0"
		},
	},
	data() {
		return {
			// Data for bar chart.
		}
	},
})

</script>